var ModalComment = {
  view: function (ctrl, args) {

    return m('div.dm-overlay',
      m("div.dm-table", [
        m("div.dm-cell", [
          m("div.dm-modal", [
            m(".bg-primary[style='padding:10px;z-index:1;']", [
              m("span[id='modalTitleLmc'][style='margin-right: 15px']", "Предупреждение"),
              m("span.pull-right[style='cursor: pointer;']", {
                onclick: ModalContainerComment.close
              }, [
                m("i.glyphicon.glyphicon-remove"),
                m.trust('&nbsp;Закрыть')
              ])
            ]),
            [
              m("div", [
                m("div[style='margin: 15px 0; padding: 0 15px;']", [
                  m("div[style='']", [
                    m("div[id='modalContentLmc'][style='text-align: center']", "Укажите причину отклонения Loadsheet"),
                    m(".row[style='text-align: center; margin-top: 15px']", [
                      m("button.btn.btn-warning.btn-lg", {
                        //id: "",
                        onclick: function () {
                          ModalContainerComment.close();
                        }
                      }, "Закрыть сообщение")
                    ]),
                  ]),
                ])
              ])
            ]
          ])
        ])
      ])
    );
  }
};

export var ModalContainerComment = {
  container: null,
  idElement: null,
  init: function () {
    ModalContainerComment.container = document.querySelector('#ModalComment');
    if (!ModalContainerComment.container) {
      ModalContainerComment.container = document.createElement('div');
      ModalContainerComment.container.id = 'ModalComment';
      ModalContainerComment.container.hidden = true;
      document.body.appendChild(ModalContainerComment.container);
      m.mount(ModalContainerComment.container, m.component(ModalComment, {data:  "", type: false, idElement: ""}));
    }
  },
  open: function (title, message, buttons= null, idElement = null) {
    ModalContainerComment.container = document.querySelector('#ModalComment');
    if(typeof(idElement) != "undefined" && idElement !== null)
      ModalContainerComment.idElement = idElement;
    if(typeof(removeAll) != "undefined" && removeAll !== null)
      ModalContainerComment.removeAll = removeAll;
    if (ModalContainerComment.container) {
      // if(title){
      // document.getElementById("modalTitleLmc").innerHTML = title;
      // }
      // if(message){
      // document.getElementById("modalContentLmc").innerHTML = message;
      // }
      /*if(buttons){
          document.getElementById("modalButtons").innerHTML = "";
          document.getElementById("modalButtons").append(buttons);
      }*/


      ModalContainerComment.container.hidden = false;
    }
  },
  close: function () {
    ModalContainerComment.container.hidden = true;
  }
};
